<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1 class="m-0">Sucursal - Moneda e IGV</h1>
                </div><!-- /.col -->
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
                        <li class="breadcrumb-item active">Moneda</li>
                    </ol>
                </div><!-- /.col -->
            </div><!-- /.row -->
        </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

    <div class="row">
        <div class="col-md-6">
            <!-- Sucursales -->
            <div class="card card-secondary">
                <div class="card-header">
                    <h3 class="card-title">Sucursales</h3>
                </div>
                <div class="card-body">
                    <div class="mb-2">
                        <button type="button" class="btn btn-success btn-sm" @click="abrirModalSucursal('registrar')">Nuevo</button>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Dirección</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in arraySucursal" :key="s.id">
                                <td v-text="s.nombre"></td>
                                <td v-text="s.direccion"></td>
                                <td>
                                    <button class="btn btn-sm btn-warning ml-2" @click="abrirModalSucursal('actualizar', s)"><i class="fas fa-edit"></i></button>&nbsp;
                                    <button v-if="s.activo" class="btn btn-sm btn-danger" @click="eliminarSucursal(s.id,s.nombre,s.activo)"><i class="fas fa-trash-alt"></i></button>
                                    <button v-else class="btn btn-sm btn-success" @click="eliminarSucursal(s.id,s.nombre,s.activo)"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                                    <span v-if="s.activo" class="badge badge-success">Habilitad</span>
                                    <span v-else class="badge badge-danger">Anulado</span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Sucursales -->
                  <!-- ALMACEN -->
            <div class="card card-secondary">
                <div class="card-header">
                    <h3 class="card-title">Almacen</h3>
                </div>
                <div class="card-body">
                    <div class="mb-2">
                        <button type="button" class="btn btn-success btn-sm" @click="abrirModalAlmacen('registrar')">Nuevo</button>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Dirección</th>
                                <th>Sucursal</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="arrayAlmacen.length === 0">
                                <td colspan="4" class="text-danger">* Agregue almacen</td>
                            </tr>
                            <tr v-for="a in arrayAlmacen" :key="a.id">
                                <td v-text="a.nombre"></td>
                                <td v-text="a.direccion"></td>
                                <td v-text="a.sucursal"></td>
                                <td>
                                    <button class="btn btn-sm btn-warning ml-2" @click="abrirModalAlmacen('actualizar', a)"><i class="fas fa-edit"></i></button>&nbsp;
                                    <button v-if="a.activo" class="btn btn-sm btn-danger" @click="eliminarAlmacen(a.id,a.nombre,a.activo)"><i class="fas fa-trash-alt"></i></button>
                                    <button v-else class="btn btn-sm btn-success" @click="eliminarAlmacen(a.id,a.nombre,a.activo)"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                                    <span v-if="a.activo" class="badge badge-success">Habilitad</span>
                                    <span v-else class="badge badge-danger">Anulado</span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- ALMACEN -->
        </div>
        <!--- MODAL SUCURSAL --->
        <div v-if="showModalSuc">
            <div class="modal">
                <div class="modal-overlay"></div>
                    <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarSucursal():actualizarSucursal()">
                        <div class="modal-header bg-primary text-white">
                            <h4>{{tituloModal}}</h4>
                            <button type="button" class="close" @click="cerrarModal()">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3 row">
                                <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="nombreSucur" placeholder="Nombre Sucursal" style="text-transform:uppercase;">
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label for="" class="col-sm-3 col-form-label">Dirección:</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="direccion" placeholder="Calle..." style="text-transform:uppercase;">
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                            <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarSucursal()">GUARDAR</button>
                            <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarSucursal()">ACTUALIZAR</button>
                        </div>
                    </div>
                </div>
                
            </div>
            <!--- FIN MODAL SUCURSAL --->

               <!--- MODAL ALMACEN --->
        <div v-if="showModalAlm">
            <div class="modal">
                <div class="modal-overlay"></div>
                    <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarAlmacen():actualizarAlmacen()">
                        <div class="modal-header bg-primary text-white">
                            <h4>{{tituloModal}}</h4>
                            <button type="button" class="close" @click="cerrarModal()">&times;</button>
                        </div>
                        <div class="modal-body">
                            <div class="mb-3 row">
                                <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="nombreAlmacen" placeholder="Local 001" style="text-transform:uppercase;">
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label for="" class="col-sm-3 col-form-label">Dirección: *</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="direccionAlmacen" placeholder="Calle..." style="text-transform:uppercase;">
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label for="" class="col-sm-3 col-form-label">Sucursal: *</label>
                                <div class="col-sm-9">
                                  <select v-model="sucursalAlmacen"  class="form-control">
                                      <option :value="null">==seleccione==</option>
                                      <option :value="su.id" v-for="su in arraySucursal" :key="su.id" v-text="su.nombre"></option>
                                  </select>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                            <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarAlmacen()">GUARDAR</button>
                            <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarAlmacen()">ACTUALIZAR</button>
                        </div>
                    </div>
                </div>
                
            </div>
            <!--- FIN MODAL ALMACEN --->


        <div class="col-md-6">
            <div class="card card-info">
                <div class="card-header">
                    <h3 class="card-title">Tipo de monedas</h3>
                </div>
              <!-- /.card-header -->
              <!-- form start -->
                
                <div class="card-body">
                    <div class="mb-2">
                        <button type="button" class="btn btn-success btn-sm" >Nuevo</button>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Código</th>
                                <th>Simbolo</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="m in arrayMoneda" :key="m.id">
                                <td v-text="m.nombre"></td>
                                <td v-text="m.codigo"></td>
                                <td v-text="m.simbolo"></td>
                                <td>
                                    <button class="btn btn-sm btn-warning ml-2" ><i class="fas fa-edit"></i></button>&nbsp;
                                    <button v-if="m.activo" class="btn btn-sm btn-danger" ><i class="fas fa-trash-alt"></i></button>
                                    <button v-else class="btn btn-sm btn-success"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                                    <span v-if="m.activo" class="badge badge-success">Habilitad</span>
                                    <span v-else class="badge badge-danger">Anulado</span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- tipo comprobante -->
            <div class="card card-info">
                <div class="card-header">
                    <h3 class="card-title">IGV</h3>
                </div>
              <!-- /.card-header -->
              <!-- form start -->
                
                <div class="card-body">
                    <div class="mb-2">
                        <h4>Impuesto general a las ventas: <strong>{{igv}} %</strong> </h4>
                    </div>
                    <div class="input-group mb-3" >
                        <div class="input-group-prepend">
                            <span class="input-group-text">IGV</span>
                        </div>
                        <input type="number" class="form-control" placeholder="0" v-model="newIgv">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" >Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.tipo comprobante -->
        </div>
    </div>
</template>

<script>
    export default{   
        data(){
            return{
                id:'',
                idSuc:'',
                nombre:'',
                simbolo:'',
                codigo:'',
                activo:'',
                arrayMoneda:[],
                arrayIgv:[],
                arraySucursal:[],
                arrayAlmacen:[],
                igv:'',
                newIgv:'',
                idconcepto:'',
                nombreSucur:'',
                direccion:'',

                nombreAlmacen:'',
                direccionAlmacen:'',
                sucursalAlmacen:null,
                idAlmacen:'',

                errorMoneda:0,
                arrayMostMsj:[],
                errorSucursal:0,
                errorAlmacen:0,
                arrayMostMsjSucursal:[],
                arrayMostMsjAlmacen:[],
                errorIgv:0,
                arrayMsjIgv:[],
                idEmpresa:'',

                showModal:false,
                showModalSuc:false,
                showModalAlm:false,
                errorSaveUpdate:[],
            }
        },
      computed: {
        
      },
      methods:{          
          listarMoneda(){
              let me = this
              this.$axios.get(`apiempresa/moneda/`)
              .then(function(response){
                if(response.data.length){
                    me.arrayMoneda = response.data
                }
              })
          },
          listarIgv(){
              let me = this
              this.$axios.get(`apiempresa/conceptoconfig/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                if(response.data.length){
                    me.igv = response.data[0]['impuesto'] //igv
                    me.idconcepto = response.data[0]['id']
                    me.newIgv = me.igv
                }
              })
          },
          listarSucursal(){
              let me = this
              this.$axios.get(`apimaster/sucursal/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                if(response.data.length){
                    me.arraySucursal = response.data
                }
              })
          },
          listarAlmacen(){
              let me = this
              this.$axios.get(`apiempresa/almacen/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                if(response.data.length){
                    me.arrayAlmacen = response.data
                }
              })
              console.log(this.arrayAlmacen)
          },
          validarIgv(){
            this.errorIgv = 0
            this.arrayMsjIgv = []
            const igvValue = parseFloat(this.newIgv)
            if(isNaN(igvValue) || igvValue < 0) this.arrayMsjIgv.push("Ingrese un valor de IGV válido")
            if(this.arrayMsjIgv.length) this.errorIgv = 1
            return this.errorIgv
          },
          saveUpdateIgv(){
            if(this.validarIgv()){
                this.arrayMsjIgv.forEach(element => {
                    this.$toastr.error(element,'Atencion!')
                });
                return
            }
            let me = this
            if(this.idconcepto){ 
             // Actualizar
                this.$axios.put(`apiempresa/impuesto/`+me.idconcepto+`/`, {
                    impuesto: me.newIgv
                })
                .then(function (response) {
                    me.listarIgv()
                    console.log(response)
                    me.$toastr.success('IGV registrado', 'Actualizado');
                })
            }
          },
          validar(){
              this.errorMoneda = 0
              this.arrayMostMsj = []
              if(!this.nombre.trim()) this.arrayMostMsj.push("Ingrese nombre de la moneda")
              if(!this.codigo.trim()) this.arrayMostMsj.push("Ingrese el codigo de la moneda")
              if(!this.simbolo.trim()) this.arrayMostMsj.push("Ingrese el simbolo de la moneda")
              if(this.arrayMostMsj.length) this.errorMoneda = 1
              return this.errorMoneda
          },
          validarAlmacen(){
              this.errorAlmacen = 0
              this.arrayMostMsjAlmacen = []
              if(!this.nombreAlmacen.trim()) this.arrayMostMsjAlmacen.push("Ingrese nombre del Almacen")
              if(!this.direccionAlmacen.trim()) this.arrayMostMsjAlmacen.push("Ingrese una direccion del Almacen")
              if(!this.sucursalAlmacen) this.arrayMostMsjAlmacen.push("Elija una sucursal")
              if(this.arrayMostMsjAlmacen.length) this.errorAlmacen = 1
              return this.errorAlmacen
          },
          validarSucursal(){
              this.errorSucursal = 0
              this.arrayMostMsjSucursal = []
              if(!this.nombreSucur.trim()) this.arrayMostMsjSucursal.push("Ingrese nombre de Sucursal")
              if(!this.direccion.trim()) this.arrayMostMsjSucursal.push("Ingrese una direccion de la sucursal")
              if(this.arrayMostMsjSucursal.length) this.errorSucursal = 1
              return this.errorSucursal
          },
          registrarSucursal(){
            if(this.validarSucursal()){
                this.arrayMostMsjSucursal.forEach(element => {
                  this.$toastr.error(element,'Atencion!')
              });
              return
            }
            let me = this
            this.$axios.post(`apimaster/sucursal/`, {
                nombre: (me.nombreSucur.toUpperCase()).trim(),
                direccion: (me.direccion.toUpperCase()).trim(),
                idEmpresa: me.idEmpresa,
            })
            .then(function (response) {
                me.listarSucursal()
                console.log(response)
                me.cerrarModal()
                me.$toastr.success('Nuevo Sucursal', 'Registrado');
            })
            .catch(function(error){
                var msg = error.response.data.error
                me.$toastr.error(msg, 'Error');
                console.log(error.response.data)
            })
          },
          actualizarSucursal(){
              if(this.validarSucursal()){
                  this.arrayMostMsjSucursal.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              this.$axios.patch(`apimaster/sucursal/`+me.idSuc+`/`,{
                nombre: (me.nombreSucur.toUpperCase()).trim(),
                direccion: (me.direccion.toUpperCase()).trim(),
              })
              .then(function(response){
                  console.log(response)
                  me.listarSucursal()
                  me.cerrarModal()
                  me.$toastr.success('Sucursal actualizado', 'Actualizado');
              })
          },
          eliminarSucursal(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text:  activo ? 'Presione si para eliminar' : 'Presione si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Eliminar' : 'Restaurar',
              }).then((result) => {
              if (result.isConfirmed) {
                  this.$axios.put(`apimaster/sucursal/`+id+`/`,{
                      activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarSucursal()
                      me.cerrarModal()
                      if(activo){me.$toastr.success('Local deshabilitado', 'Desactivado')}
                      else{me.$toastr.success('Local Habilitado', 'Habilitado')}
                  })
              }
              })
          },
          

          registrarAlmacen(){
            if(this.validarAlmacen()){
                this.arrayMostMsjAlmacen.forEach(element => {
                  this.$toastr.error(element,'Atencion!')
              });
              return
            }
            let me = this
            this.$axios.post(`apiempresa/almacen/`, {
                nombre: (me.nombreAlmacen.toUpperCase()).trim(),
                direccion: (me.direccionAlmacen.toUpperCase()).trim(),
                idSucursal: me.sucursalAlmacen,
                idEmpresa: me.idEmpresa,
            })
            .then(function (response) {
                console.log(response)
                me.listarAlmacen()
                me.cerrarModal()
                me.$toastr.success('Nuevo Almacen', 'Registrado');
            })
            .catch(function(error){
                var msg = error.response.data.error
                me.$toastr.error(msg, 'Error');
                console.log(error.response.data)
            })
          },
          actualizarAlmacen(){
              if(this.validarAlmacen()){
                  this.arrayMostMsjAlmacen.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              this.$axios.patch(`apiempresa/almacen/`+me.idAlmacen+`/`,{
                nombre: (me.nombreAlmacen.toUpperCase()).trim(),
                direccion: (me.direccionAlmacen.toUpperCase()).trim(),
                idSucursal: me.sucursalAlmacen,
              })
              .then(function(response){
                  console.log(response)
                  me.listarAlmacen()
                  me.cerrarModal()
                  me.$toastr.success('Almacen actualizado', 'Actualizado');
              })
          },
          eliminarAlmacen(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text:  activo ? 'Presione si para eliminar' : 'Presione si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Eliminar' : 'Restaurar',
              }).then((result) => {
              if (result.isConfirmed) {
                  this.$axios.patch(`apiempresa/almacen/`+id+`/`,{
                      activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarAlmacen()
                      me.cerrarModal()
                      if(activo){me.$toastr.success('Almacen deshabilitado', 'Desactivado')}
                      else{me.$toastr.success('Almacen Habilitado', 'Habilitado')}
                  })
              }
              })
          },

          abrirModalSucursal(action, data=[]){
              switch(action){
                  case "registrar":{
                      this.showModalSuc = true
                      this.tituloModal = "Nueva Sucursal"
                      this.tipoAccion = 1
                      break
                  }
                  case "actualizar":{
                      this.showModalSuc = true
                      this.tituloModal = "Editar Sucursal"
                      this.idSuc = data['id']
                      this.nombreSucur = data['nombre']
                      this.direccion = data['direccion']
                      this.tipoAccion = 2
                      break
                  }
              }                
          },

          abrirModalAlmacen(action, data=[]){
              switch(action){
                  case "registrar":{
                      this.showModalAlm = true
                      this.tituloModal = "Nuevo Almacen"
                      this.tipoAccion = 1
                      break
                  }
                  case "actualizar":{
                      this.showModalAlm = true
                      this.tituloModal = "Editar Almacen"
                      this.idAlmacen = data['id']
                      this.nombreAlmacen = data['nombre']
                      this.direccionAlmacen = data['direccion']
                      this.sucursalAlmacen = data['idSucursal']
                      this.tipoAccion = 2
                      break
                  }
              }                
          },

          cerrarModal(){
              this.showModal = false
              this.showModalSuc = false
              this.showModalAlm = false
              this.id = ''
              this.idAlmacen=''
              this.nombre = ''
              this.nombreSucur = ''
              this.codigo = ''
              this.simbolo = ''
              this.direccion = ''
              this.nombreAlmacen=''
              this.direccionAlmacen=''
              this.sucursalAlmacen=null
          },
          //=========FIN DE COMPROBANTES=============//
      },
      watch: {
      },
      mounted(){
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.listarMoneda()
          this.listarIgv()
          this.listarSucursal()
          this.listarAlmacen()
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
</style>